import { render } from "./FieldsetPreferences.vue?vue&type=template&id=66bef156&ts=true"
import script from "./FieldsetPreferences.vue?vue&type=script&lang=ts"
export * from "./FieldsetPreferences.vue?vue&type=script&lang=ts"

import "./FieldsetPreferences.vue?vue&type=style&index=0&id=66bef156&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__